export default {
  manifest_force_overtime: 'dsch049',
  manifest_force_as_addon: 'cdm001'
};
